import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

export function initMainMatchesSliders() {
        let swipers = $('.main-matches-slider');
        swipers.each(function() {
        let swiper = new Swiper(this, {
            speed: 900,
            preloadImages: false,
            spaceBetween: 16,
            allowTouchMove: true,
            slidesPerView: 'auto',
            pagination: {
                el: '.main-matches-slider-pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: '.main-matches-swiper-next',
                prevEl: '.main-matches-swiper-prev',
            },
            breakpoints: {
                768: {
                    spaceBetween: 32,
                },
                1026: {
                    allowTouchMove: false,
                },
            },
        });
    });
}